<template>
  <div class="grid" :class="[`grid--${col}`, { 'grid--indent': indent, 'grid--revers-mobile': revers_mobile }]">
    <div v-for="item in arr" :key="item" class="grid__item">
      <slot :name="`item-${item}`" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppGrid',
  props: {
    col: {
      type: String,
      default: '2',
      validator: value => {
        return value <= 6
      }
    },
    items: {
      type: String,
      default: '2'
    },
    indent: {
      type: Boolean,
      default: false
    },
    revers_mobile: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      arr: []
    }
  },
  mounted() {
    for (let i = 1; i <= this.items; i++) {
      this.arr.push(i)
    }
  }
}
</script>

<style lang="sass">
.grid
  display: grid
  gap: 20px

.grid--2
  grid-template-columns: repeat(2, minmax(45%, 1fr))

.grid--2-half
  grid-template-columns: 1fr 1fr

.grid--2-cashflow
  grid-template-columns: 300px 1fr

.grid--3
  grid-template-columns: repeat(3, 1fr)

.grid--4
  grid-template-columns: repeat(4, 1fr)

.grid--5
  grid-template-columns: repeat(5, 1fr)

.grid--6
  grid-template-columns: repeat(6, 1fr)

.grid--indent
  margin-bottom: 30px

.grid--align-center
  align-items: center

.grid__item
  gap: 20px
</style>
